<script>
import users from '../services/users'
import progress from '../services/progress'
export default {
	data() {
		return {
			users: [],
			progress: []
		}
	},

	async mounted() {
		let datausers = await users.all()
		let dataprogress = await progress.all()
		datausers = datausers.map(u => {
			let progress = dataprogress.filter(p => p.userId == u._id)

			u.avance = progress

			return u
		})
		this.$set(this, 'users', datausers)
		this.$set(this, 'progress', dataprogress)
	}
}
</script>
<template>
	<div>
		<h1>Datos</h1>
		<h5>Usuarios</h5>
		<ul>
			<li v-for="user in users">
				ID: {{user._id}} |
				Nombre: {{user.name}} |
				Codigo: {{user.code}} |
				Desbloquedos: {{ user.unlocks || 'ninguno' }}
				<h5>Avance</h5>
				<ul>
					<li v-for="item in user.avance">
						{{ item.title }} | {{ item.type }} |
						Visto: {{ item.viewed ? 'Si' : 'No' }} |
						Completado: {{ item.completed ? 'Si' : 'No' }}
					
					</li>
				</ul>
			</li>
		</ul>

	
	</div>
</template>